import React from 'react'

const Background = () => {
  return (
    <span className='BREAKER'>BREAKER</span>
  )
}

export default Background